/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetPerformanceByPageCountQueryResponse, IngestionStatusControllerGetPerformanceByPageCountQueryParams, IngestionStatusControllerGetPerformanceByPageCount403 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetPerformanceByPageCount";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { ingestionStatusControllerGetPerformanceByPageCount } from "../../clients/document-ingestion-statusService/ingestionStatusControllerGetPerformanceByPageCount";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const ingestionStatusControllerGetPerformanceByPageCountQueryKey = (params: IngestionStatusControllerGetPerformanceByPageCountQueryParams = {}) => [{
  url: '/api/v1/documents/ingestion-status/performance-by-page-count'
}, ...(params ? [params] : [])] as const;
export type IngestionStatusControllerGetPerformanceByPageCountQueryKey = ReturnType<typeof ingestionStatusControllerGetPerformanceByPageCountQueryKey>;
export function ingestionStatusControllerGetPerformanceByPageCountQueryOptions(params?: IngestionStatusControllerGetPerformanceByPageCountQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = ingestionStatusControllerGetPerformanceByPageCountQueryKey(params);
  return queryOptions<IngestionStatusControllerGetPerformanceByPageCountQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetPerformanceByPageCount403>, IngestionStatusControllerGetPerformanceByPageCountQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return ingestionStatusControllerGetPerformanceByPageCount(params, config);
    }
  });
}

/**
 * @description Returns processing time statistics grouped by document page count buckets (1-10, 11-50, 51-100, 100+). Includes P50, P90, P99 percentiles for both overall and per-step timing. Requires System Administrator role.
 * @summary Get performance metrics by document page count
 * {@link /api/v1/documents/ingestion-status/performance-by-page-count}
 */
export function useIngestionStatusControllerGetPerformanceByPageCount<TData = IngestionStatusControllerGetPerformanceByPageCountQueryResponse, TQueryData = IngestionStatusControllerGetPerformanceByPageCountQueryResponse, TQueryKey extends QueryKey = IngestionStatusControllerGetPerformanceByPageCountQueryKey>(params?: IngestionStatusControllerGetPerformanceByPageCountQueryParams, options: {
  query?: Partial<QueryObserverOptions<IngestionStatusControllerGetPerformanceByPageCountQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetPerformanceByPageCount403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? ingestionStatusControllerGetPerformanceByPageCountQueryKey(params);
  const query = useQuery({
    ...ingestionStatusControllerGetPerformanceByPageCountQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<IngestionStatusControllerGetPerformanceByPageCount403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}